'use strict';

var MapConfig = {};

MapConfig.tileLayers = {
  mapbox: {
    name: 'mapbox',
    url: 'https://api.mapbox.com/v4/{user}.{mapId}/{z}/{x}/{y}.png?access_token={token}',
    type: 'xyz',
    layerOptions: {
      mapId: 'satellite',
      user: 'mapbox',
      token: 'pk.eyJ1Ijoic2t5Y2F0Y2gtZGV2IiwiYSI6Ik1PVjVYNEkifQ.j2X9OOZDz7ABqUvHk4kesw',
      maxNativeZoom: 19
    },
  },
  datacapture: {
    name: 'datacapture',
    url: 'https://{s}-tiles.skycatch.com/{layerId}/{z}/{x}/{y}.png',
    type: 'xyz'
  },
  overlay: {
    name: 'overlay',
    url: 'https://{s}-tiles.skycatch.com/{layerId}/{z}/{x}/{y}.png',
    type: 'xyz',
    layerOptions: {
      zIndex: 5
    }
  }
};

MapConfig.mapDefaults = {
  attributionControl: false,
  center: { lat: 37.772061, lng: -122.409927, zoom: 16 },
  controls: {
    layers: {
      visible: false
    }
  },
  tileLayerOptions: {
    detectRetina: false,
    reuseTiles: true,
    maxNativeZoom: 21,
    maxZoom: 24
  },
  latlng: { lat: 37.772061, lng: -122.409927 },
  minZoom: 12,
  zoom: 17,
  maxZoom: 24,
  zoomControl: false,
  keyboard: false,
  zoomControlPosition: 'bottomright'
};

// The only way to disable all events from angular-leaflet is to pass the `enable` param
// an empty array.
MapConfig.events = {
  map: {
    logic: 'emit',
    enable: ['layeradd']
  },
  marker: {
    logic: 'emit',
    enable: []
  },
  path: {
    logic: 'emit',
    enable: []
  }
};

module.exports = MapConfig;



// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/map/src/app/config/config.js